<template>
    <div class="flex flex-col w-full gap-y-6">
        <div class="flex gap-x-3 items-center">
            <span class="text-md text-gray-900">Do Not Disturb</span>
            <InputSwitch v-model="workflowStore.doNotDisturb.isEnabled" @change="enable"></InputSwitch>
        </div>

        <div v-if="workflowStore.doNotDisturb.isEnabled" class="flex w-full gap-x-4 gap-y-2 flex-grow items-center">
            <GgmsInput v-model="workflowStore.doNotDisturb.number" class="w-full"></GgmsInput>
            <GgmsDropdown
                v-model="workflowStore.doNotDisturb.period"
                :options="options"
                option-value="value"
                option-label="label"
                class="w-full"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import { watch } from "vue"
import { useWorkflowStore } from "@/stores/workflow"
import { DoNotDisturbPeriod } from "@/shared/models/workflow"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsDropdown from "@/components/GgmsDropdown.vue"

const workflowStore = useWorkflowStore()

const options = [
    { label: "Day(s)", value: DoNotDisturbPeriod.day },
    { label: "Week(s)", value: DoNotDisturbPeriod.week },
    { label: "Month(s)", value: DoNotDisturbPeriod.month },
    { label: "Year(s)", value: DoNotDisturbPeriod.year },
]

function enable() {
    if (workflowStore.doNotDisturb.isEnabled) {
        workflowStore.doNotDisturb.number = 1
        workflowStore.doNotDisturb.period = DoNotDisturbPeriod.day
    }
}

watch(
    () => workflowStore.doNotDisturb,
    () => {
        workflowStore.areButtonDisabled =
            workflowStore.doNotDisturb.isEnabled &&
            (!workflowStore.doNotDisturb.number || workflowStore.doNotDisturb.number === 0) &&
            !workflowStore.doNotDisturb.period
    },
    { deep: true }
)
</script>
